"use client";

import * as React from "react";
import styles from "./styles.module.css";

function Card({ children, className, ...props }) {
  return (
    <div className={`${styles.card} ${className || ""}`} {...props}>
      {children}
    </div>
  );
}

const CardContent = React.forwardRef(function CardContent(
  { className, children, ...props },
  ref
) {
  return (
    <div
      ref={ref}
      className={`${styles.cardContent} ${className || ""}`}
      {...props}
    >
      {children}
    </div>
  );
});

const CardBody = React.forwardRef(function CardBody(
  { className, ...props },
  ref
) {
  return (
    <div
      ref={ref}
      className={`${styles.cardBody} ${className || ""}`}
      {...props}
    />
  );
});

const CardHeader = React.forwardRef(function CardHeader(
  { className, ...props },
  ref
) {
  return (
    <div
      ref={ref}
      className={`${styles.cardHeader} ${className || ""}`}
      {...props}
    />
  );
});

const CardTitle = React.forwardRef(function CardTitle(
  { className, ...props },
  ref
) {
  return (
    <h2
      ref={ref}
      className={`${styles.cardTitle} ${className || ""}`}
      {...props}
    />
  );
});

const CardDescription = React.forwardRef(function CardDescription(
  { className, ...props },
  ref
) {
  return (
    <p
      ref={ref}
      className={`${styles.cardDescription} ${className || ""}`}
      {...props}
    />
  );
});

const CardFooter = React.forwardRef(function CardFooter(
  { className, ...props },
  ref
) {
  return (
    <div
      ref={ref}
      className={`${styles.cardFooter} ${className || ""}`}
      {...props}
    />
  );
});

export {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
  CardFooter,
  CardBody,
};
